import {
    doLoginAsComprador as doLoginAsCompradorApi,
    doLoginAsFornecedor as doLoginAsFornecedorApi,
    doLoginAsCompradorEmAnalise as doLoginAsCompradorEmAnaliseApi,
    doLoginAsFornecedorEmAnalise as doLoginAsFornecedorEmAnaliseApi,
    doLoginAsEmployee as doLoginAsEmployeeApi,
    getAllMenuPages
} from "../../api/auth";
import sortBy from "lodash.sortby";
import flatten from 'lodash.flatten';

export const LOGIN_MODES = {
    CLIENT: 'comprador',
    FORNECEDOR: 'fornecedor',
    EMPLOYEE: 'usuario'
}

export default {
    namespaced: true,
    state: {
        loginType: null,
        token: null,
        user: null,
        menu: null
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_USER(state, user) {
            state.user = user;
        },
        SET_LOGIN_TYPE(state, type) {
            state.loginType = type;
        },
        SET_MENU(state, menu) {
            state.menu = menu;
        }
    },
    getters: {
        user(state) {
            return state.user;
        },
        token(state) {
            return state.token;
        },
        loginType(state) {
            return state.loginType;
        },
        isAuthenticated(state) {
            return state.user != null && state.token != null && state.menu != null;
        },
        nivelUsuarioLogado(state) {
            let nivel = '';
            if (state.user != null && state.token != null && state.menu != null) nivel = state.user.nivel;
            return nivel;
        },
        menu(state) {
            return state.menu;
        },
        authorizedLinks(state) {
            const authorizedLinksAux = state.menu
                ? state.menu.flatMap(item => [
                    item.link !== "#" ? item.link : null,  // Verifica o link do pai
                    ...item.childrens.map(child => child.link !== "#" ? child.link : null) // Verifica os links dos filhos
                    ]).filter(Boolean)  // Remove valores nulos/undefined
                : [];
            const rotasPublicas = ["/conf-senha","/esqueci-a-senha","/cadastre-se"];
            return authorizedLinksAux.concat(rotasPublicas);            
        },
        routes(state) {
            return state.menu ? flatten(state.menu.map(menu => menu.childrens)) : [];
        }
    },
    actions: {
        doLoginAsComprador({commit}, {login, password}) {
            return doLoginAsCompradorApi(login, password).then(({token, current}) => {
                commit('SET_TOKEN', token);
                commit('SET_USER', current);
                commit('SET_LOGIN_TYPE', LOGIN_MODES.CLIENT);
            })
        },
        doLoginAsFornecedor({commit}, {login, password}) {
            return doLoginAsFornecedorApi(login, password).then(({token, current}) => {
                commit('SET_TOKEN', token);
                commit('SET_USER', current);
                commit('SET_LOGIN_TYPE', LOGIN_MODES.FORNECEDOR);
            })
        },
        doLoginAsCompradorEmAnalise({commit}, {login, password}) {
            return doLoginAsCompradorEmAnaliseApi(login, password).then(({token, current}) => {
                commit('SET_TOKEN', token);
                commit('SET_USER', current);
                commit('SET_LOGIN_TYPE', LOGIN_MODES.CLIENT);
            })
        },
        doLoginAsFornecedorEmAnalise({commit}, {login, password}) {
            return doLoginAsFornecedorEmAnaliseApi(login, password).then(({token, current}) => {
                commit('SET_TOKEN', token);
                commit('SET_USER', current);
                commit('SET_LOGIN_TYPE', LOGIN_MODES.FORNECEDOR);
            })
        },
        doLoginAsEmployee({commit}, {login, password}) {
            return doLoginAsEmployeeApi(login, password).then(({token, current}) => {
                commit('SET_TOKEN', token);
                commit('SET_USER', current);
                commit('SET_LOGIN_TYPE', LOGIN_MODES.EMPLOYEE);
            })
        },
        async doLoginFornCompEmAnalise({dispatch, commit, getters}, {type, login, password}) {
            await dispatch('doLogout');

            switch (type) {
                case LOGIN_MODES.FORNECEDOR:
                    await dispatch('doLoginAsFornecedorEmAnalise', {login, password});
                    break;
                case LOGIN_MODES.CLIENT:
                    await dispatch('doLoginAsCompradorEmAnalise', {login, password});
                    break;
                default:
                    throw new Error('Tipo de login publico invalido.');
            }

            commit('SET_MENU', null);

            return {
                token: getters.token,
                current: getters.user
            };
        },
        async doLogin({dispatch, commit}, {type, login, password}) {
            // console.log({type, login, password});
             try {
                 switch (type) {
                    case LOGIN_MODES.EMPLOYEE:
                        await dispatch('doLoginAsEmployee', {login, password});
                        break;
                    case LOGIN_MODES.FORNECEDOR:
                        await dispatch('doLoginAsFornecedor', {login, password});
                        break;
                    default:
                        await dispatch('doLoginAsComprador',  {login, password});
                        break;
                 }

                 const menu = await getAllMenuPages()
                     .then(menus => {
                         return sortBy(menus.map(menu => ({
                             icon: menu.icon,
                             title: menu.titulo,
                             order: menu.ordem,
                             link: menu.url,
                             childrens: sortBy(menu.filhos.filter(item => item.url !== '').map(children => ({
                                 title: children.titulo,
                                 order: children.ordem,
                                 link: children.url,
                                 icon: children.icon,
                                 searchTerms: [menu.titulo, ...children.titulo.split(' ')],
                                 searchDescription: `${menu.titulo} de ${children.titulo}`,
                                 searchable: true
                             })),['order'])
                         })),['order']);

                     });
                 //console.log(menu);
                 commit('SET_MENU', menu);
             } catch (err) {
                 await dispatch('doLogout');
                 throw err;
             }
        },
        getDefaultHomePage({getters}) {
            if(getters.loginType === LOGIN_MODES.EMPLOYEE) {
                return 'Dashboard Fornecedor'
            } else {
                return 'Painel'
            }
        },
        getDefaultLoginPage({getters}) {
            return 'Login'
        },
        doLogout({commit}) {
            commit('SET_TOKEN', null);
            commit('SET_USER', null);
            commit('SET_MENU', null);
        }
    }
}